// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analysis-results-page {
  min-height: 100vh;
  background: #f5f7fa;
}

.analysis-results-page .app-header {
  margin-bottom: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

/* Layout with Sidebar */
.analysis-page-layout {
  display: flex;
  min-height: calc(100vh - 60px);
  padding-top: 60px;
}

/* Sidebar Styles */
.analysis-sidebar {
  width: 280px;
  background: white;
  border-right: 1px solid #e0e0e0;
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  overflow-y: auto;
  transition: width 0.3s ease, transform 0.3s ease;
  z-index: 50;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
}

.analysis-sidebar.collapsed {
  width: 50px;
}

.sidebar-toggle {
  width: 28px;
  height: 28px;
  border: none;
  background: #f0f0f0;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #666;
  transition: all 0.2s;
  flex-shrink: 0;
}

.sidebar-toggle:hover {
  background: #e0e0e0;
  color: #333;
}

.collapsed-toggle {
  margin: 12px auto;
  margin-top: 24px;
  display: block;
}

.sidebar-header {
  padding: 20px 16px;
  margin-top: 12px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.sidebar-user {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}

.user-avatar {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
}

.user-name {
  font-weight: 600;
  color: #333;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-nav {
  padding: 12px 0;
}

.nav-section {
  margin-bottom: 20px;
}

.nav-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.add-folder-btn {
  width: 24px;
  height: 24px;
  border: none;
  background: #667eea;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.add-folder-btn:hover {
  background: #5568d3;
  transform: scale(1.1);
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #555;
  text-align: left;
  transition: all 0.2s;
}

.nav-item:hover {
  background: #f5f7fa;
  color: #333;
}

.nav-item.active {
  background: linear-gradient(90deg, #667eea15, transparent);
  color: #667eea;
  border-left: 3px solid #667eea;
  font-weight: 600;
}

.nav-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.nav-label {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-count {
  background: #f0f0f0;
  color: #666;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.nav-item.active .nav-count {
  background: #667eea20;
  color: #667eea;
}

.no-folders-text {
  padding: 12px 16px;
  color: #999;
  font-size: 13px;
  font-style: italic;
}

.folder-item-wrapper {
  position: relative;
}

.folder-item-wrapper:hover .folder-actions {
  opacity: 1;
}

.folder-actions {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s;
}

.folder-action-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: #f5f5f5;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.folder-action-btn:hover {
  background: #e0e0e0;
}

.folder-action-btn.delete:hover {
  background: #fee;
}

.folder-edit-form {
  display: flex;
  gap: 4px;
  padding: 8px 12px;
}

.folder-edit-form input {
  flex: 1 1;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
}

.folder-edit-form button {
  width: 28px;
  height: 28px;
  border: none;
  background: #f5f5f5;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.folder-edit-form button:first-of-type:hover {
  background: #d4edda;
}

.folder-edit-form button:last-of-type:hover {
  background: #fee;
}

/* Main Content */
.analysis-main-content {
  flex: 1 1;
  margin-left: 280px;
  transition: margin-left 0.3s ease;
}

.analysis-sidebar.collapsed + .analysis-main-content {
  margin-left: 50px;
}

.analysis-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 40px 20px;
}

.analysis-header {
  margin-bottom: 30px;
}

.analysis-header h1 {
  font-size: 28px;
  color: #333;
  margin: 15px 0 8px;
}

.subtitle {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.back-button {
  background: none;
  border: none;
  color: #667eea;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 0;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.back-button:hover {
  text-decoration: underline;
}

.empty-state {
  background: white;
  border-radius: 12px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.empty-state h3 {
  font-size: 20px;
  color: #333;
  margin: 0 0 10px;
}

.empty-state p {
  color: #666;
  font-size: 14px;
  margin: 0 0 30px;
}

.primary-button {
  background: #667eea;
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: background 0.2s;
}

.primary-button:hover {
  background: #5568d3;
}

.analyses-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.analysis-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}

.analysis-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.analysis-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.analysis-main-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 38px; /* match actions height */
}

.analysis-main-info h3 {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  line-height: normal; /* avoid arbitrary shifts */
  color: #333;
  margin: 0 0 6px;
  min-width: 0;
}

.analysis-meta {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #666;
}

.analysis-id {
  font-family: monospace;
  background: #f5f5f5;
  padding: 2px 8px;
  border-radius: 4px;
}

.status-badge {
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-completed {
  background: #d4edda;
  color: #155724;
}

.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-failed {
  background: #f8d7da;
  color: #721c24;
}

.analysis-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.view-button,
.download-button {
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.view-button {
  background: #667eea;
  color: white;
}

.view-button:hover {
  background: #5568d3;
}

.download-button {
  background: #34d399;
  color: white;
}

.download-button:hover {
  background: #10b981;
}

.error-message {
  background: #fef5f5;
  color: #e74c3c;
  padding: 12px 16px;
  border-radius: 6px;
  border: 1px solid #fcc;
  font-size: 14px;
  margin-bottom: 20px;
}

/* Results Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 12px;
  max-width: 1200px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.modal-close:hover {
  background: #f0f0f0;
  color: #333;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

.results-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 24px;
}

.result-item {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e0e0e0;
}

.result-image-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.result-image {
  width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.open-full-link {
  color: #667eea;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}

.open-full-link:hover {
  text-decoration: underline;
}

.result-file {
  padding: 16px;
  background: white;
  border-radius: 6px;
  text-align: center;
}

.result-file a {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
}

.result-file a:hover {
  text-decoration: underline;
}

/* Grouped analyses styles */
.analysis-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #667eea;
  color: white;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  flex: 0 0 auto;
  padding: 4px 10px;
  border-radius: 12px;
  margin-left: 0;
}

/* Search Bar */
.search-bar {
  position: relative;
  margin-top: 16px;
  max-width: 400px;
}

.search-input {
  width: 100%;
  padding: 12px 40px 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.clear-search {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: none;
  background: #f0f0f0;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}

.clear-search:hover {
  background: #e0e0e0;
  color: #333;
}

/* Favorite Button */
.analysis-card-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  /* Push up slightly to physically align the 36px tall 
     favorite button with the 24px tall H3 title. */
  margin-top: -6px;
}

.favorite-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 24px;
  color: #ccc;
  transition: all 0.2s;
  border-radius: 50%;
}

.favorite-btn:hover {
  color: #fbbf24;
  background: #fef3c7;
}

.favorite-btn.active {
  color: #f59e0b;
}

.analysis-card.favorite {
  border-left: 4px solid #f59e0b;
}

/* Folder Tag on Analysis Card */
.analysis-folder-tag {
  background: #f0f0f0;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  color: #666;
}

/* Additional Action Buttons */
.list-button,
.delete-button {
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.list-button {
  background: #f0f0f0;
  color: #555;
}

.list-button:hover {
  background: #e0e0e0;
  color: #333;
}

.delete-button {
  background: #fee;
  color: #c53030;
}

.delete-button:hover {
  background: #fcc;
}

/* Modal Styles */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.modal-box {
  background: white;
  border-radius: 16px;
  padding: 32px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  text-align: center;
  animation: modalSlideIn 0.2s ease;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-box.list-modal {
  max-width: 360px;
  padding: 28px;
}

.modal-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.modal-icon.danger {
  background: #fee;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 36px;
}

.modal-box h3 {
  margin: 0 0 8px;
  font-size: 20px;
  color: #1a1a1a;
  font-weight: 600;
}

.modal-desc {
  margin: 0 0 24px;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.delete-warning {
  color: #c53030;
  display: block;
  margin-top: 8px;
}

.modal-input {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e8e8e8;
  border-radius: 10px;
  font-size: 15px;
  margin-bottom: 10px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.modal-input:focus {
  outline: none;
  border-color: #667eea;
}

.modal-input.error {
  border-color: #ef4444;
}

.modal-error {
  color: #ef4444;
  font-size: 13px;
  margin: 0 0 16px 0;
  text-align: left;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.modal-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 100px;
}

.modal-btn.small {
  padding: 10px 16px;
  min-width: auto;
}

.modal-btn.primary {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}

.modal-btn.primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.modal-btn.primary:disabled {
  background: #ccc;
  transform: none;
  box-shadow: none;
  cursor: not-allowed;
}

.modal-btn.secondary {
  background: #f5f5f5;
  color: #555;
}

.modal-btn.secondary:hover {
  background: #e8e8e8;
}

.modal-btn.danger {
  background: #e53e3e;
  color: white;
}

.modal-btn.danger:hover {
  background: #c53030;
}

/* List Panel in Modal */
.list-panel-content {
  max-height: 250px;
  overflow-y: auto;
  margin-bottom: 20px;
  text-align: left;
}

.list-checkbox {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s;
  margin-bottom: 4px;
}

.list-checkbox:hover {
  background: #f5f7fa;
}

.list-checkbox input {
  display: none;
}

.list-checkbox .checkmark {
  width: 22px;
  height: 22px;
  border: 2px solid #ddd;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}

.list-checkbox input:checked + .checkmark {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-color: #667eea;
}

.list-checkbox input:checked + .checkmark::after {
  content: '✓';
  color: white;
  font-size: 13px;
  font-weight: bold;
}

.list-checkbox .list-name {
  color: #333;
  font-size: 15px;
}

.no-lists-box {
  text-align: center;
  padding: 24px;
  color: #999;
}

.no-lists-box span {
  font-size: 40px;
  display: block;
  margin-bottom: 12px;
}

.no-lists-box p {
  margin: 0 0 16px;
  font-size: 14px;
}

/* Analysis Name Edit Styles */
.analysis-name-edit {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  width: 100%;
}

.analysis-name-input {
  flex: 0 0 320px;
  padding: 8px 12px;
  border: 2px solid #667eea;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  min-width: 0;
  width: 320px;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
}

.analysis-name-input:focus {
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.name-save-btn,
.name-cancel-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.name-save-btn {
  background: #4caf50;
  color: white;
}

.name-save-btn:hover {
  background: #43a047;
}

.name-cancel-btn {
  background: #f0f0f0;
  color: #666;
}

.name-cancel-btn:hover {
  background: #e0e0e0;
  color: #333;
}

.analysis-name-link {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
}

.analysis-name-text {
  color: inherit;
  display: inline-flex;
  align-items: center;
  flex: 0 1 auto;
  min-width: 0;
  max-width: calc(100% - 34px); /* reserve space for pen icon and gap */
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
}

.analysis-name-text-inner {
  display: inline-block;
  line-height: normal; /* remove fixed line-height to fix vertical shift */
  white-space: nowrap;
  will-change: transform;
}


.analysis-name-text:hover {
  color: #667eea;
  text-decoration: underline;
}

.analysis-name-link.is-overflowing .analysis-name-text:hover .analysis-name-text-inner,
.analysis-name-link.is-overflowing .analysis-name-text:focus-visible .analysis-name-text-inner {
  animation: analysis-name-scroll var(--analysis-scroll-duration, 6s) linear infinite alternate;
}

@keyframes analysis-name-scroll {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(calc(-1 * var(--analysis-scroll-distance, 0px)));
  }
}

.rename-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  line-height: normal; /* to fit perfectly inside 22x22 box */
  width: 22px;
  height: 22px;
  padding: 0;
  margin-left: 0;
  opacity: 0;
  transition: opacity 0.2s;
}

.analysis-card:hover .rename-btn {
  opacity: 0.6;
}

.rename-btn:hover {
  opacity: 1 !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .analysis-sidebar {
    transform: translateX(-100%);
    width: 280px;
  }
  
  .analysis-sidebar.open {
    transform: translateX(0);
  }
  
  .analysis-main-content {
    margin-left: 0;
  }
  
  .sidebar-toggle {
    position: fixed;
    top: 70px;
    left: 10px;
    z-index: 60;
    background: white;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .analysis-sidebar.open + .analysis-main-content .sidebar-toggle {
    left: 290px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/AnalysisResultsPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,SAAS;EACT,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,gDAAgD;EAChD,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0DAA0D;EAC1D,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB,EAAE,yBAAyB;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB,EAAE,2BAA2B;EAChD,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;mDACiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA,8BAA8B;AAC9B;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,4BAA4B,EAAE,uCAAuC;EACrE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB,EAAE,mDAAmD;EACxE,mBAAmB;EACnB,sBAAsB;AACxB;;;AAGA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,6FAA6F;AAC/F;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sEAAsE;EACxE;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB,EAAE,sCAAsC;EAC3D,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,4BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,qCAAqC;EACvC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".analysis-results-page {\n  min-height: 100vh;\n  background: #f5f7fa;\n}\n\n.analysis-results-page .app-header {\n  margin-bottom: 0;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n}\n\n/* Layout with Sidebar */\n.analysis-page-layout {\n  display: flex;\n  min-height: calc(100vh - 60px);\n  padding-top: 60px;\n}\n\n/* Sidebar Styles */\n.analysis-sidebar {\n  width: 280px;\n  background: white;\n  border-right: 1px solid #e0e0e0;\n  position: fixed;\n  top: 60px;\n  left: 0;\n  bottom: 0;\n  overflow-y: auto;\n  transition: width 0.3s ease, transform 0.3s ease;\n  z-index: 50;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);\n}\n\n.analysis-sidebar.collapsed {\n  width: 50px;\n}\n\n.sidebar-toggle {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: #f0f0f0;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  color: #666;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.sidebar-toggle:hover {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.collapsed-toggle {\n  margin: 12px auto;\n  margin-top: 24px;\n  display: block;\n}\n\n.sidebar-header {\n  padding: 20px 16px;\n  margin-top: 12px;\n  border-bottom: 1px solid #f0f0f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.sidebar-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n\n.user-avatar {\n  width: 36px;\n  height: 36px;\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.user-name {\n  font-weight: 600;\n  color: #333;\n  font-size: 15px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-nav {\n  padding: 12px 0;\n}\n\n.nav-section {\n  margin-bottom: 20px;\n}\n\n.nav-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #999;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.add-folder-btn {\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: #667eea;\n  color: white;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.add-folder-btn:hover {\n  background: #5568d3;\n  transform: scale(1.1);\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #555;\n  text-align: left;\n  transition: all 0.2s;\n}\n\n.nav-item:hover {\n  background: #f5f7fa;\n  color: #333;\n}\n\n.nav-item.active {\n  background: linear-gradient(90deg, #667eea15, transparent);\n  color: #667eea;\n  border-left: 3px solid #667eea;\n  font-weight: 600;\n}\n\n.nav-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.nav-label {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.nav-count {\n  background: #f0f0f0;\n  color: #666;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.nav-item.active .nav-count {\n  background: #667eea20;\n  color: #667eea;\n}\n\n.no-folders-text {\n  padding: 12px 16px;\n  color: #999;\n  font-size: 13px;\n  font-style: italic;\n}\n\n.folder-item-wrapper {\n  position: relative;\n}\n\n.folder-item-wrapper:hover .folder-actions {\n  opacity: 1;\n}\n\n.folder-actions {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  gap: 4px;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.folder-action-btn {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: #f5f5f5;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.folder-action-btn:hover {\n  background: #e0e0e0;\n}\n\n.folder-action-btn.delete:hover {\n  background: #fee;\n}\n\n.folder-edit-form {\n  display: flex;\n  gap: 4px;\n  padding: 8px 12px;\n}\n\n.folder-edit-form input {\n  flex: 1;\n  padding: 6px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.folder-edit-form button {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: #f5f5f5;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.folder-edit-form button:first-of-type:hover {\n  background: #d4edda;\n}\n\n.folder-edit-form button:last-of-type:hover {\n  background: #fee;\n}\n\n/* Main Content */\n.analysis-main-content {\n  flex: 1;\n  margin-left: 280px;\n  transition: margin-left 0.3s ease;\n}\n\n.analysis-sidebar.collapsed + .analysis-main-content {\n  margin-left: 50px;\n}\n\n.analysis-container {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n\n.analysis-header {\n  margin-bottom: 30px;\n}\n\n.analysis-header h1 {\n  font-size: 28px;\n  color: #333;\n  margin: 15px 0 8px;\n}\n\n.subtitle {\n  color: #666;\n  font-size: 14px;\n  margin: 0;\n}\n\n.back-button {\n  background: none;\n  border: none;\n  color: #667eea;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 8px 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.back-button:hover {\n  text-decoration: underline;\n}\n\n.empty-state {\n  background: white;\n  border-radius: 12px;\n  padding: 60px 40px;\n  text-align: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.empty-icon {\n  font-size: 64px;\n  margin-bottom: 20px;\n}\n\n.empty-state h3 {\n  font-size: 20px;\n  color: #333;\n  margin: 0 0 10px;\n}\n\n.empty-state p {\n  color: #666;\n  font-size: 14px;\n  margin: 0 0 30px;\n}\n\n.primary-button {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600;\n  transition: background 0.2s;\n}\n\n.primary-button:hover {\n  background: #5568d3;\n}\n\n.analyses-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.analysis-card {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.analysis-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.analysis-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 16px;\n}\n\n.analysis-main-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 38px; /* match actions height */\n}\n\n.analysis-main-info h3 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 18px;\n  line-height: normal; /* avoid arbitrary shifts */\n  color: #333;\n  margin: 0 0 6px;\n  min-width: 0;\n}\n\n.analysis-meta {\n  display: flex;\n  gap: 16px;\n  font-size: 13px;\n  color: #666;\n}\n\n.analysis-id {\n  font-family: monospace;\n  background: #f5f5f5;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.status-badge {\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-completed {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-pending {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.status-failed {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.analysis-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.view-button,\n.download-button {\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.view-button {\n  background: #667eea;\n  color: white;\n}\n\n.view-button:hover {\n  background: #5568d3;\n}\n\n.download-button {\n  background: #34d399;\n  color: white;\n}\n\n.download-button:hover {\n  background: #10b981;\n}\n\n.error-message {\n  background: #fef5f5;\n  color: #e74c3c;\n  padding: 12px 16px;\n  border-radius: 6px;\n  border: 1px solid #fcc;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n/* Results Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  max-width: 1200px;\n  width: 100%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  color: #333;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #999;\n  cursor: pointer;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s;\n}\n\n.modal-close:hover {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.results-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 24px;\n}\n\n.result-item {\n  background: #f9f9f9;\n  border-radius: 8px;\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n}\n\n.result-image-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.result-image {\n  width: 100%;\n  height: auto;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.open-full-link {\n  color: #667eea;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.open-full-link:hover {\n  text-decoration: underline;\n}\n\n.result-file {\n  padding: 16px;\n  background: white;\n  border-radius: 6px;\n  text-align: center;\n}\n\n.result-file a {\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.result-file a:hover {\n  text-decoration: underline;\n}\n\n/* Grouped analyses styles */\n.analysis-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #667eea;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n  flex: 0 0 auto;\n  padding: 4px 10px;\n  border-radius: 12px;\n  margin-left: 0;\n}\n\n/* Search Bar */\n.search-bar {\n  position: relative;\n  margin-top: 16px;\n  max-width: 400px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 40px 12px 16px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.clear-search {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: #f0f0f0;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #666;\n}\n\n.clear-search:hover {\n  background: #e0e0e0;\n  color: #333;\n}\n\n/* Favorite Button */\n.analysis-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  /* Push up slightly to physically align the 36px tall \n     favorite button with the 24px tall H3 title. */\n  margin-top: -6px;\n}\n\n.favorite-btn {\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 24px;\n  color: #ccc;\n  transition: all 0.2s;\n  border-radius: 50%;\n}\n\n.favorite-btn:hover {\n  color: #fbbf24;\n  background: #fef3c7;\n}\n\n.favorite-btn.active {\n  color: #f59e0b;\n}\n\n.analysis-card.favorite {\n  border-left: 4px solid #f59e0b;\n}\n\n/* Folder Tag on Analysis Card */\n.analysis-folder-tag {\n  background: #f0f0f0;\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  color: #666;\n}\n\n/* Additional Action Buttons */\n.list-button,\n.delete-button {\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.list-button {\n  background: #f0f0f0;\n  color: #555;\n}\n\n.list-button:hover {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.delete-button {\n  background: #fee;\n  color: #c53030;\n}\n\n.delete-button:hover {\n  background: #fcc;\n}\n\n/* Modal Styles */\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(2px);\n}\n\n.modal-box {\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  animation: modalSlideIn 0.2s ease;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.modal-box.list-modal {\n  max-width: 360px;\n  padding: 28px;\n}\n\n.modal-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.modal-icon.danger {\n  background: #fee;\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n  font-size: 36px;\n}\n\n.modal-box h3 {\n  margin: 0 0 8px;\n  font-size: 20px;\n  color: #1a1a1a;\n  font-weight: 600;\n}\n\n.modal-desc {\n  margin: 0 0 24px;\n  color: #666;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.delete-warning {\n  color: #c53030;\n  display: block;\n  margin-top: 8px;\n}\n\n.modal-input {\n  width: 100%;\n  padding: 14px 16px;\n  border: 2px solid #e8e8e8;\n  border-radius: 10px;\n  font-size: 15px;\n  margin-bottom: 10px;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n\n.modal-input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.modal-input.error {\n  border-color: #ef4444;\n}\n\n.modal-error {\n  color: #ef4444;\n  font-size: 13px;\n  margin: 0 0 16px 0;\n  text-align: left;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.modal-btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 100px;\n}\n\n.modal-btn.small {\n  padding: 10px 16px;\n  min-width: auto;\n}\n\n.modal-btn.primary {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n}\n\n.modal-btn.primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.modal-btn.primary:disabled {\n  background: #ccc;\n  transform: none;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.modal-btn.secondary {\n  background: #f5f5f5;\n  color: #555;\n}\n\n.modal-btn.secondary:hover {\n  background: #e8e8e8;\n}\n\n.modal-btn.danger {\n  background: #e53e3e;\n  color: white;\n}\n\n.modal-btn.danger:hover {\n  background: #c53030;\n}\n\n/* List Panel in Modal */\n.list-panel-content {\n  max-height: 250px;\n  overflow-y: auto;\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.list-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-bottom: 4px;\n}\n\n.list-checkbox:hover {\n  background: #f5f7fa;\n}\n\n.list-checkbox input {\n  display: none;\n}\n\n.list-checkbox .checkmark {\n  width: 22px;\n  height: 22px;\n  border: 2px solid #ddd;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.list-checkbox input:checked + .checkmark {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  border-color: #667eea;\n}\n\n.list-checkbox input:checked + .checkmark::after {\n  content: '✓';\n  color: white;\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.list-checkbox .list-name {\n  color: #333;\n  font-size: 15px;\n}\n\n.no-lists-box {\n  text-align: center;\n  padding: 24px;\n  color: #999;\n}\n\n.no-lists-box span {\n  font-size: 40px;\n  display: block;\n  margin-bottom: 12px;\n}\n\n.no-lists-box p {\n  margin: 0 0 16px;\n  font-size: 14px;\n}\n\n/* Analysis Name Edit Styles */\n.analysis-name-edit {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  width: 100%;\n}\n\n.analysis-name-input {\n  flex: 0 0 320px;\n  padding: 8px 12px;\n  border: 2px solid #667eea;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  outline: none;\n  min-width: 0;\n  width: 320px;\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: clip;\n}\n\n.analysis-name-input:focus {\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n}\n\n.name-save-btn,\n.name-cancel-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.name-save-btn {\n  background: #4caf50;\n  color: white;\n}\n\n.name-save-btn:hover {\n  background: #43a047;\n}\n\n.name-cancel-btn {\n  background: #f0f0f0;\n  color: #666;\n}\n\n.name-cancel-btn:hover {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.analysis-name-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.analysis-name-text {\n  color: inherit;\n  display: inline-flex;\n  align-items: center;\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: calc(100% - 34px); /* reserve space for pen icon and gap */\n  overflow: hidden;\n  cursor: pointer;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.analysis-name-text-inner {\n  display: inline-block;\n  line-height: normal; /* remove fixed line-height to fix vertical shift */\n  white-space: nowrap;\n  will-change: transform;\n}\n\n\n.analysis-name-text:hover {\n  color: #667eea;\n  text-decoration: underline;\n}\n\n.analysis-name-link.is-overflowing .analysis-name-text:hover .analysis-name-text-inner,\n.analysis-name-link.is-overflowing .analysis-name-text:focus-visible .analysis-name-text-inner {\n  animation: analysis-name-scroll var(--analysis-scroll-duration, 6s) linear infinite alternate;\n}\n\n@keyframes analysis-name-scroll {\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(calc(-1 * var(--analysis-scroll-distance, 0px)));\n  }\n}\n\n.rename-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: normal; /* to fit perfectly inside 22x22 box */\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  margin-left: 0;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.analysis-card:hover .rename-btn {\n  opacity: 0.6;\n}\n\n.rename-btn:hover {\n  opacity: 1 !important;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .analysis-sidebar {\n    transform: translateX(-100%);\n    width: 280px;\n  }\n  \n  .analysis-sidebar.open {\n    transform: translateX(0);\n  }\n  \n  .analysis-main-content {\n    margin-left: 0;\n  }\n  \n  .sidebar-toggle {\n    position: fixed;\n    top: 70px;\n    left: 10px;\n    z-index: 60;\n    background: white;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  }\n  \n  .analysis-sidebar.open + .analysis-main-content .sidebar-toggle {\n    left: 290px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
